import { useLayout } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { hocs as pageHocs } from 'modules/page';
import { memo } from 'react';
import { useSelector } from 'react-redux';

import Loading from '../[workflowId]/loading';
import { Content } from '../[workflowId]/page';
import { pageConfig } from './config';
import useNewWorkflowPageData from './resources/hooks/useNewWorkflowPageData';

const Page = memo(() => {
    const innerActivePageId = useSelector(selectors.navigation.getInnerActivePageId);

    useLayout({ hasHeader: true, hasDrawer: true });

    const { isInitialLoading } = useNewWorkflowPageData();

    if (isInitialLoading || innerActivePageId !== pageConfig.innerActivePageId) {
        return <Loading />;
    }

    return <Content />;
});

export default pageHocs.withProtected({ Page, roles: pageConfig.access });
